import { reviewStartApi } from "../../api/review/reviewStartApi"

type PayloadShape = Parameters<typeof reviewStartApi>[0]

export async function reviewStartService(payload: PayloadShape, token: string) {
	return await reviewStartApi(payload, token)
}
